// Sidebar.tsx
import { mainItems, shortcuts } from "./data/sideData";
import { SidebarItem } from "./SidebarItem";

export default function Sidebar() {
  return (
    <>
      {/* ---------------- Desktop Sidebar ---------------- */}
      <div className="hidden md:block max-w-[300px] w-full rounded-2xl bg-white dark:bg-deepSlate">
        <nav className="space-y-1">
          {mainItems.map((item) => (
            <SidebarItem key={item.label} item={item} />
          ))}
        </nav>

        <hr className="my-4 border-gray-200 dark:border-gray-700" />

        <div>
          <h3 className="px-3 mb-2 text-xs font-semibold uppercase text-gray-500">
            Your shortcuts
          </h3>

          <nav className="space-y-1">
            {shortcuts.map((item) => (
              <SidebarItem key={item.label} item={item} />
            ))}
          </nav>
        </div>
      </div>

      {/* ---------------- Mobile Sidebar ---------------- */}
      <div className="md:hidden bg-white dark:bg-deepSlate border-b dark:border-gray-700">
        <div className="py-3">
          
          {/* Main Navigation */}
          <nav className="flex gap-3 overflow-x-auto px-4 pb-2 scrollbar-hide">
            {mainItems.map((item) => (
              <div
                key={item.label}
                className="flex-shrink-0 min-w-fit"
              >
                <SidebarItem item={item} />
              </div>
            ))}
          </nav>

          {/* Divider */}
          <hr className="my-3 border-gray-200 dark:border-gray-700" />

          {/* Shortcuts */}
          <h3 className="px-4 mb-2 text-xs font-semibold uppercase text-gray-500">
            Shortcuts
          </h3>

          <nav className="flex gap-3 overflow-x-auto px-4 pb-2 scrollbar-hide">
            {shortcuts.map((item) => (
              <div
                key={item.label}
                className="flex-shrink-0 min-w-fit"
              >
                <SidebarItem item={item} />
              </div>
            ))}
          </nav>
        </div>
      </div>
    </>
  );
}